// extracted by mini-css-extract-plugin
export var labelWrapper = "_di-0";